import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { tenantSubDomainQueryParam, tokenQueryParam } from '../../constants';
import { AuthService, FirebaseWrapperService, TenantFacadeService } from '../../services';
import { redirectToOrigin } from '@anecdotes/utils';

@Component({
  selector: 'app-token-callback',
  template: '',
})
export class TokenCallbackComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private tenantFacade: TenantFacadeService,
    private firebaseWrapper: FirebaseWrapperService
  ) {}

  ngOnInit(): void {
    this.init();
  }

  async init(): Promise<void> {
    const token = this.route.snapshot.queryParamMap.get(tokenQueryParam);
    const tenantSubDomain = this.route.snapshot.queryParamMap.get(tenantSubDomainQueryParam);

    if (token) {
      const tenant = await firstValueFrom(this.tenantFacade.getTenantBySubdomain(tenantSubDomain));
      this.firebaseWrapper.setTenantId(tenant.tenant_id);
      await this.authService.signInWithTokenAsync(token);
    }
    redirectToOrigin();
  }
}
